import React, { useState } from 'react';
import { WietzTatbestandEditor } from './components/WietzTatbestandEditor';
import { WietzUeberwachung } from './components/WietzUeberwachung';

type WietzTab = 'tatbestaende' | 'ueberwachung';

const TABS: { key: WietzTab; label: string; icon: string }[] = [
  { key: 'ueberwachung', label: 'Überwachungsplan',      icon: '📅' },
  { key: 'tatbestaende', label: 'Tatbestände',           icon: '📋' },
];

export function WietzModul(): React.JSX.Element {
  const [tab, setTab] = useState<WietzTab>('tatbestaende');

  return (
    <div className="flex flex-col h-full">
      <div className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-6 pt-4 flex gap-1">
        {TABS.map(t => (
          <button key={t.key}
            onClick={() => { setTab(t.key); }}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors
              ${tab === t.key
                ? 'border-blue-600 text-blue-700 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}>
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto p-6 max-w-5xl mx-auto w-full">
        <div className="mb-5">
          <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">WIETZ</h1>
          <p className="text-sm text-gray-500 mt-0.5">
            Gesundheitsüberwachung bei Exposition gg. biologische Arbeitsstoffe (§§ 49–52 ASchG, AMR 4)
          </p>
        </div>
        {tab === 'tatbestaende' && <WietzTatbestandEditor />}
        {tab === 'ueberwachung' && <WietzUeberwachung />}
      </div>
    </div>
  );
}
